<template>

<v-app>
    <div id="app" data-app app-data="true" light>
        <keep-alive include="Ads">
            <router-view :key="$route.path"/>
        </keep-alive>
    </div>
    </v-app>
  
</template>

<script>

import { RefData } from '@/referenceData/refData';
import {DB} from '@/firebase/db';
import dataStore from '@/firebase/dataStore';
import moment from 'moment';
import {signOffPendingSeafarerList} from '@/Globals'

export default {   
    name: 'App',  
    data() {
        return { 
            signOffPendingSeafarerList,
        }
    },
    
    methods: {
        async init(){
            await this.initDropDowns();
            await this.initNotifications();
        },
        async initNotifications(){
            await this.initSignOffPendingSeafarers();
        },
        async initSignOffPendingSeafarers(){
            this.signOffPendingSeafarerList = []

            var reportDate = moment().add(30, 'days');
            var time = reportDate.valueOf();
            const seafarers = await dataStore.getAll("seafarers", [['approxSignOffDate', "<=", time]], []);             
            for(const seafarer of seafarers){
                var approxSignOffDate = moment(seafarer.approxSignOffDate);
                approxSignOffDate = approxSignOffDate.format("DD/MM/YYYY");
                signOffPendingSeafarerList.push({
                    name    : seafarer.otherName + " " + seafarer.surname,
                    approxSignOffDate : approxSignOffDate
                })
                
            }

            signOffPendingSeafarerList.sort((a,b) => a.approxSignOffDate < b.approxSignOffDate? -1 : 1)

            this.$store.commit('setSignOffPendingSeafarerList', true);
        },
        async initDropDowns(){
            const records = await DB.collection("constants").get();
            for(const doc of records.docs){
                var constant = doc.data();
                if(constant.enum == 'NOK Types'){
                    RefData.nokTypes.push(constant.text)
                }
                else if(constant.enum == 'Ranks'){
                    RefData.ranks.push(constant.text)
                }
                else if(constant.enum == 'Vessel Types'){
                    RefData.vesselTypes.push(constant.text)
                }
                else if(constant.enum == 'Pre-Join Medical Doc Types'){
                    RefData.medicalDocNamesPJ.push(constant.text)
                }
                else if(constant.enum == 'Onboard Medical Doc Types'){
                    RefData.medicalDocNamesOB.push(constant.text)
                }
                else if(constant.enum == 'Boiler Suit Sizes'){
                    RefData.boilerSuitSizes.push(constant.text)
                }
                else if(constant.enum == 'Safety Shoe Sizes'){
                    RefData.safetyShoeSizes.push(constant.text)
                }
                else if(constant.enum == 'Collar Sizes'){
                    RefData.collarSizes.push(constant.text)
                }
                else if(constant.enum == 'STCW Doc Types'){
                    RefData.stcwDocTypes.push(constant.text)
                }
                else if(constant.enum == 'Other Doc Types'){
                    RefData.otherDocTypes.push(constant.text)
                }
                else if(constant.enum == 'Status'){
                    RefData.status.push(constant.text)
                }
                else if(constant.enum == 'Sea Experience Sign Off Reasons'){
                    RefData.seaExperienceReasons.push(constant.text)
                }
            }
            
        }
    },
    created(){
        this.init();
    }
}

</script>


<style lang="scss">
:root {
  --theme-color     : #1e73be;
  --bg-color        : #e6ecf1;
  --bg-color-panel  : #F5F5F5;
  --title-color     : #696969;;
  --form-label-color: #5e6e87;;
}



#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  background: var(--bg-color-panel);
  overflow-x: hidden;
  
  // If /* Expand body to fit content height */
//   display:table;  
//   width:100%; 
  // ELSE
  // Keep the above two lines commented
  // END IF

}

#app .ilabel{
    text-align: left;
    font-weight:bold;
    font-size:12px;
    color:var(--form-label-color)
}
#app .form-group.required .ilabel:after { 
   content:"*";
   color:red;
   padding-left:2px;
}
#app .itextinput{
    border-style: solid;
    border-color: #BEBEBE;
    border-radius: 5px;
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 10px;
    padding-right: 10px;
    font-size:12px;
}

#app .ireadOnyFormKey{
    text-align: left;
    font-weight:bold;
    font-size:14px;
    color:var(--form-label-color);
    padding: 0;
    padding-left:25px;
    padding-right:5px;
    padding-top:5px;
}
#app .ireadOnyFormValue{
    text-align: left;
    font-weight:bold;
    font-size:14px;
    color:var(--title-color);
    padding: 0;
    padding-left:5px;
    padding-right:5px;
}

#app .iHScrollable{
    overflow-x: auto;
    white-space: nowrap;
}

#app .ipannel{
    background-color:var(--bg-color-panel);
    padding:20px;
}

#app .ipannelwithborder{
    background-color:var(--bg-color-panel);
    border-style: solid;
    border-width:thin;
    border-radius:7px;
    border-color:var(--theme-color);
    padding:20px;
}

#app .iscreentitleDiv{
    padding-top:10px;
    padding-bottom:20px
}

#app .iscreentitle{
    font-size:16px;
    font-weight: bold;
    color:var(--title-color)
}

#app .ibutton{
    font-size:12px;
}

#app .iselect{
    padding-top: 0;
    padding-bottom: 0;
    font-size:12px;

}

#app .KSpinner {
    padding-top: 100px;
    padding-bottom: 100px;
}

#app .bg-white{
    background: white;
}

#app .bg-theme{
    background: #e6ecf1;
}

#app .full-height{
    height: 100%;
}

// input[type="text"] {
// //   background:#d3e2e9;
// //    background:#dbeef7;
//    background:#e7f0f5;
// }
// input[type="text"]:disabled {
//   background:#e7f0f5;
// }
// #app .KNavTab{
//   background:#e7f0f5;
// }
// #app .KSelect {
//   background:#e7f0f5;
//   color:black;
//   border-color: #BEBEBE;
// }
// #app .KSelect:disabled {
//   background:#e7f0f5;
//   color:black;
//   border-color: #BEBEBE;
// }

#app .footerStickedToBottom{
    position: fixed;
    bottom: 0;
    padding:0;
    margin:0;
}

#app .embossedContainerWithRoundedCorners {
  border-radius: 10px;
  background:white;
  margin-top: 10vh;
  padding-top: 0px;
  padding-left: 50px;    
  padding-right: 50px;
  box-shadow: 0px 0px 10px 2px var(--theme-color);
}
</style>
